// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// Utils
import { getEMRErrorMessage } from "src/utils/emr/emrErrorHelper";

// API
import { deleteEMRPacServer } from "../../api";

export const useDeleteEMRPacServer = (
  clinicId: string | undefined,
  hubId: string | undefined
) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (pacServerId: string) => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      return deleteEMRPacServer(token, clinicId, pacServerId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["emr-pac-servers", clinicId, hubId],
      });
      queryClient.invalidateQueries({
        queryKey: ["emr-hub-connections", clinicId, hubId],
      });
      setSnackbarInfo({
        variant: "success",
        message: t("PAC server removed successfully!"),
      });
    },
    onError: (error) => {
      setSnackbarInfo({
        variant: "error",
        message: getEMRErrorMessage(
          error,
          t("PAC server could not be removed!"),
          t
        ),
      });
    },
  });
};
